"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getModel = getModel;
exports.resetModel = resetModel;
exports.initHDSModel = initHDSModel;
const HDSModel_ts_1 = require("./HDSModel.js");
const HDSService_ts_1 = require("../HDSService.js");
const errors_ts_1 = require("../errors.js");
let hdsModelInstance = null;
function getModel() {
    if (hdsModelInstance == null) {
        hdsModelInstance = new HDSModel_ts_1.HDSModel('');
    }
    return hdsModelInstance;
}
/**
 * Mostly used during test to unload model
 */
function resetModel() {
    hdsModelInstance = null;
}
/**
 * Initialized model singleton
 */
async function initHDSModel(opts = {}) {
    if (!hdsModelInstance) {
        getModel();
    }
    if (!hdsModelInstance.isLoaded) {
        const service = new HDSService_ts_1.HDSService();
        const serviceInfo = await service.info();
        const modelUrl = serviceInfo.assets?.['hds-model'];
        if (typeof modelUrl !== 'string' || modelUrl === '') {
            throw new errors_ts_1.HDSLibError(`initHDSModel: the service info has no "hds-model" asset (assets: ${JSON.stringify(Object.keys(serviceInfo.assets ?? {}))})`);
        }
        hdsModelInstance.assets = serviceInfo.assets;
        await hdsModelInstance.load(modelUrl, opts.overload ?? null);
    }
    return hdsModelInstance;
}
